export class Result {
  constructor(errorCode = 500, data = {}, errorMess = "") {
    this.success = false;
    this.errorCode = errorCode;
    this.errorMess = data;
    this.data = errorMess;
  }
}

export class SelectEnum {
  constructor(label = "", value = "") {
    this.label = label;
    this.value = value;
  }
}
